// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"124750c4","237":"ec507660","383":"875ffa09","402":"7eafe3aa","459":"aff7d840","488":"34d873b7","594":"7c7d0bf6","661":"8396d7f7","715":"0028439a","741":"240cc20a","879":"b1730594"}[chunkId] + ".chunk.js";
};